import { IApplicationState } from '../../types/redux';

/**
 * Выбирает аналитику
 */
export const selectAnalytics = ({ analytics }: IApplicationState) => analytics;
